import useAppStateStore from "../store/AppStateStore";
import useBuyStore from "../../features/buy/store/BuyStore";
import usePanelStore from "../../features/quote/store/PanelStore";
import useQuoteStore from "../../features/quote/store/QuoteStore";
import useSupportStore from "../../features/portal/store/supportStore";
import SupportStep from "../../features/portal/enums/SupportStep";

export function updateQuoteFields(fieldMap) {
  const { updateField } = useQuoteStore.getState();
  Object.entries(fieldMap).forEach(([path, value]) => {
    updateField(path, value);
  });
}

export const clearAllStores = () => {
  useAppStateStore.persist.clearStorage();
  useAppStateStore.getState().reset();
  useQuoteStore.persist.clearStorage();
  useQuoteStore.getState().reset();
  useBuyStore.persist.clearStorage();
  useBuyStore.getState().reset();
  usePanelStore.persist.clearStorage();
  usePanelStore.getState().reset();
  console.log("All Stores cleared.");
};

export const clearAllStoresPreservingPortalCustomerData = () => {
  const appState = useAppStateStore.getState();
  const portalCustomerData = {
    customerPolicies: appState.customerPolicies,
    customerQuotes: appState.customerQuotes,
    portalCustomerDataFetchedAt: appState.portalCustomerDataFetchedAt,
    portalCustomerDataKey: appState.portalCustomerDataKey,
  };

  clearAllStores();

  const resetAppState = useAppStateStore.getState();
  resetAppState.setCustomerPolicies(portalCustomerData.customerPolicies);
  resetAppState.setCustomerQuotes(portalCustomerData.customerQuotes);
  resetAppState.setPortalCustomerDataFetchedAt(
    portalCustomerData.portalCustomerDataFetchedAt
  );
  resetAppState.setPortalCustomerDataKey(portalCustomerData.portalCustomerDataKey);
};

export const clearSupportStore = () => {
  useSupportStore.getState().clear();
  const appState = useAppStateStore.getState();
  appState.setSpCurrentStep(SupportStep.SP1);
  appState.setSelectedOptions([]);
  appState.setSupportType("");
  appState.setCancelPolicyNavigation(true);
  appState.setIsCancellationModalOpen(false);
  appState.setIsChangeModalOpen(false);
  appState.setSupportLoading(false);
  console.log("Support store cleared.");
};
